import { useContext, useEffect } from 'react';
import { HistoryColumns } from '../config/columnConfig';
import { useOutletContext } from 'react-router-dom';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import historyApi, {
  useDeleteHistorySerpMutation,
  useGetSerpHistoryQuery
} from '@/app/Serp/api/historyApi';
import DataLoadError from '@/components/errors/DataLoadError';
import {
  shouldShowDataLoadError,
  isNetworkApiError
} from '@/app/common/utils/apiErrorUtils';
import NoSerpData from '../components/common/NoSerpData';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import CancelModal from '@/app/common/components/CancelModal';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import { RemoveSerpContext } from '@/context/Context';
import { useDispatch } from 'react-redux';
import { errorMessage, successMessage } from '@/utils/toast';
import useDomain from '@/hooks/useDomain';

type BreadcrumbItem = { text: string; href: string };

type OutletContext = [BreadcrumbItem[], (items: BreadcrumbItem[]) => void];

const History = () => {
  const dispatch = useDispatch();
  const [, setBreadcrumbData] = useOutletContext<OutletContext>();
  const { domain_slug, domain } = useDomain();
  const { data: userInfo } = useGetUserInfoQuery();

  useEffect(() => {
    setBreadcrumbData([{ text: 'تاریخچه', href: '#' }]);
  }, []);

  // REMOVE HISTORY MODAL
  const {
    serpId: remSerpId,
    keyword: remKeryword,
    show: showRemModal,
    setShow: setShowRemModal
  } = useContext(RemoveSerpContext);

  const [deleteHistory] = useDeleteHistorySerpMutation();

  // دریافت تاریخچه Serp
  const { data, isLoading, isError, error, refetch, isFetching } =
    useGetSerpHistoryQuery({
      domain_slug,
      requested_user: {
        name_family: `${userInfo?.data?.first_name} ${userInfo?.data?.last_name}`,
        email: userInfo?.data?.email
      }
    });

  if (shouldShowDataLoadError(isError, error)) {
    return (
      <DataLoadError
        onRetry={() => refetch()}
        isRetrying={isFetching}
        isNetworkError={isNetworkApiError(error)}
      />
    );
  }
  if (!isLoading && !data?.data) return <NoSerpData />;

  return (
    <>
      <CancelModal
        setShow={setShowRemModal}
        show={showRemModal}
        submitTitle="آره، حذف بشه"
        title="حذف اطلاعات SERP"
        submitFunc={() => {
          deleteHistory({
            serp_id: remSerpId,
            domain_slug,
            requested_user: {
              name_family: `${userInfo?.data?.first_name} ${userInfo?.data?.last_name}`,
              email: userInfo?.data?.email
            }
          })
            .then(() => {
              successMessage('اطلاعات با موفقیت حذف شد');
              dispatch(historyApi.util.invalidateTags(['SerpHistory']));
            })
            .catch(() => {
              errorMessage('در حذف اطلاعات خطایی رخ داده');
            });
        }}
        desc={`آیا مطمئن هستید میخواهید اطلاعات ${decodeURIComponent(remKeryword)} را حذف کنید؟`}
      />
      {!isLoading ? (
        <div className="for-style">
          <AgGridWrapper
            height="746px"
            columns={HistoryColumns(domain_slug, domain)}
            data={data?.data.rows}
          />
        </div>
      ) : (
        <AgGridSkeleton height="696px" />
      )}
      <style>
        {`
            .for-style .ag-row-focus {
                z-index: 2;
          }`}
      </style>
    </>
  );
};

export default History;
